import { React, useState, useRef, useEffect } from "react";
import AgentLayout from "../components/AgentLayout";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../utils/axiosInstance";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';


const BetLock = () => { 

    const navigate = useNavigate();
    const [pageLoad, setPageLoad] = useState(false);
    const [TeenPattiStudio, handleTeenPattiStudio] = useState(true); 
    const [RoyalCasino, handleRoyalCasino] = useState(true); 
    const [BetfairGames, handleBetfairGames] = useState(true); 
    const [StarCasino, handleStarCasino] = useState(true); 
    const [SuperNowa, handleSuperNowa] = useState(true); 
    const [Figure, handleFigure] = useState(true); 
    const [Fancy, handleFancy] = useState(true); 
    const [MatchOdds, handleMatchOdds] = useState(true); 
    const [EvenOdd, handleEvenOdd] = useState(true); 
    const [Toss, handleToss] = useState(true); 
    const [Tie, handleTie] = useState(true); 
    const [CupWinner, handleCupWinner] = useState(true); 

    const [GreyhAustralia, handleGreyhAustralia] = useState(true); 
    const [GreyhBritain, handleGreyhBritain] = useState(true); 
    const [GreyhNewzealand, handleGreyhNewzealand] = useState(true); 

    const [HRaceDubai, handleHRaceDubai] = useState(true); 
    const [HRaceAustralia, handleHRaceAustralia] = useState(true); 
    const [HRaceBahrain, handleHRaceBahrain] = useState(true); 
    const [HRaceFrance, handleHRaceFrance] = useState(true); 
    const [HRaceEngland, handleHRaceEngland] = useState(true); 
    const [HRaceIreland, handleHRaceIreland] = useState(true); 
    const [HRaceNewzealand, handleHRaceNewzealand] = useState(true); 
    const [HRaceSweden, handleHRaceSweden] = useState(true); 
    const [HRaceSingapore, handleHRaceSingapore] = useState(true); 
    const [HRaceAmerica, handleHRaceAmerica] = useState(true); 
    const [HRaceAfrica, handleHRaceHRaceAfrica] = useState(true); 

    const [SoccerMatchodd, handleSoccerMatchodd] = useState(true); 
    const [SoccerOverUnder, handleSoccerOverUnder] = useState(true); 
    const [TennisMatchOdd, handleTennisMatchOdd] = useState(true); 

    const [animation, handleAnimation] = useState(false); 

    const userInfo = useSelector((state) => state.userStore);  
    
   
    
    const handleCheckbox = (e) => {
      var isChecked = e.target.checked;
      var checkedValue = e.target.value;

      if (checkedValue === "TennisMatchOdd") {
        if (isChecked) {
          handleTennisMatchOdd(true);
        } else {
          handleTennisMatchOdd(false);
        }
      }

      if (checkedValue === "SoccerOverUnder") {
        if (isChecked) {
          handleSoccerOverUnder(true);
        } else {
          handleSoccerOverUnder(false);
        }
      }

      if (checkedValue === "SoccerMatchodd") {
        if (isChecked) {
          handleSoccerMatchodd(true);
        } else {
          handleSoccerMatchodd(false);
        }
      }

      if (checkedValue === "HRaceAfrica") {
        if (isChecked) {
          handleHRaceHRaceAfrica(true);
        } else {
          handleHRaceHRaceAfrica(false);
        }
      }

      if (checkedValue === "HRaceAmerica") {
        if (isChecked) {
          handleHRaceAmerica(true);
        } else {
          handleHRaceAmerica(false);
        }
      }

      if (checkedValue === "HRaceSingapore") {
        if (isChecked) {
          handleHRaceSingapore(true);
        } else {
          handleHRaceSingapore(false);
        }
      }

      if (checkedValue === "HRaceSweden") {
        if (isChecked) {
          handleHRaceSweden(true);
        } else {
          handleHRaceSweden(false);
        }
      }

      if (checkedValue === "HRaceNewzealand") {
        if (isChecked) {
          handleHRaceNewzealand(true);
        } else {
          handleHRaceNewzealand(false);
        }
      }

      if (checkedValue === "HRaceIreland") {
        if (isChecked) {
          handleHRaceIreland(true);
        } else {
          handleHRaceIreland(false);
        }
      }

      if (checkedValue === "HRaceEngland") {
        if (isChecked) {
          handleHRaceEngland(true);
        } else {
          handleHRaceEngland(false);
        }
      }

      if (checkedValue === "HRaceFrance") {
        if (isChecked) {
          handleHRaceFrance(true);
        } else {
          handleHRaceFrance(false);
        }
      }

      if (checkedValue === "HRaceBahrain") {
        if (isChecked) {
          handleHRaceBahrain(true);
        } else {
          handleHRaceBahrain(false);
        }
      }

      if (checkedValue === "HRaceAustralia") {
        if (isChecked) {
          handleHRaceAustralia(true);
        } else {
          handleHRaceAustralia(false);
        }
      }

      if (checkedValue === "HRaceDubai") {
        if (isChecked) {
          handleHRaceDubai(true);
        } else {
          handleHRaceDubai(false);
        }
      }

      if (checkedValue === "GreyhNewzealand") {
        if (isChecked) {
          handleGreyhNewzealand(true);
        } else {
          handleGreyhNewzealand(false);
        }
      }

      if (checkedValue === "GreyhBritain") {
        if (isChecked) {
          handleGreyhBritain(true);
        } else {
          handleGreyhBritain(false);
        }
      }

      if (checkedValue === "GreyhAustralia") {
        if (isChecked) {
          handleGreyhAustralia(true);
        } else {
          handleGreyhAustralia(false);
        }
      }

      if (checkedValue === "CupWinner") {
        if (isChecked) {
          handleCupWinner(true);
        } else {
          handleCupWinner(false);
        }
      }

      if (checkedValue === "Tie") {
        if (isChecked) {
          handleTie(true);
        } else {
          handleTie(false);
        }
      }

      if (checkedValue === "Toss") {
        if (isChecked) {
          handleToss(true);
        } else {
          handleToss(false);
        }
      }

      if (checkedValue === "EvenOdd") {
        if (isChecked) {
          handleEvenOdd(true);
        } else {
          handleEvenOdd(false);
        }
      }

      if (checkedValue === "MatchOdds") {
        if (isChecked) {
          handleMatchOdds(true);
        } else {
          handleMatchOdds(false);
        }
      }

      if (checkedValue === "Fancy") {
        if (isChecked) {
          handleFancy(true);
        } else {
          handleFancy(false);
        }
      }

      if (checkedValue === "TeenPattiStudio") {
        if (isChecked) {
          handleTeenPattiStudio(true);
        } else {
          handleTeenPattiStudio(false);
        }
      }

      if (checkedValue === "RoyalCasino") {
        if (isChecked) {
          handleRoyalCasino(true);
        } else {
          handleRoyalCasino(false);
        }
      }

      if (checkedValue === "BetfairGames") {
        if (isChecked) {
          handleBetfairGames(true);
        } else {
          handleBetfairGames(false);
        }
      }

      if (checkedValue === "StarCasino") {
        if (isChecked) {
          handleStarCasino(true);
        } else {
          handleStarCasino(false);
        }
      }

      if (checkedValue === "SuperNowa") {
        if (isChecked) {
          handleSuperNowa(true);
        } else {
          handleSuperNowa(false);
        }
      }

      if (checkedValue === "Figure") {
        if (isChecked) {
          handleFigure(true);
        } else {
          handleFigure(false);
        }
      }
    };

    const getUserLockSetting = async () => {
      try {
        if (userInfo !== null && userInfo.data !== null) {
          let userId = userInfo.data._id;
          const response = await axiosInstance.get(
            "/company/get-bet-lock/" + userId
          );

          if (
            response.data != null &&
            response.data.lockdata !== null &&
            response.data.lockdata !== undefined
          ) {
            let lockData = response.data?.lockdata;

            setPageLoad(true);

            if (lockData?.tennis_matchodd === 1) {
              handleTennisMatchOdd(true);
            } else {
              handleTennisMatchOdd(false);
            }

            if (lockData?.soccer_over_under === 1) {
              handleSoccerOverUnder(true);
            } else {
              handleSoccerOverUnder(false);
            }

            if (lockData?.soccer_matchodd === 1) {
              handleSoccerMatchodd(true);
            } else {
              handleSoccerMatchodd(false);
            }

            if (lockData?.hrace_sweden === 1) {
              handleHRaceSweden(true);
            } else {
              handleHRaceSweden(false);
            }

            if (lockData?.hrace_singapore === 1) {
              handleHRaceSingapore(true);
            } else {
              handleHRaceSingapore(false);
            }

            if (lockData?.hrace_newzealand === 1) {
              handleHRaceNewzealand(true);
            } else {
              handleHRaceNewzealand(false);
            }

            if (lockData?.hrace_ireland === 1) {
              handleHRaceIreland(true);
            } else {
              handleHRaceIreland(false);
            }

            if (lockData?.hrace_france === 1) {
              handleHRaceFrance(true);
            } else {
              handleHRaceFrance(false);
            }

            if (lockData?.hrace_england === 1) {
              handleHRaceEngland(true);
            } else {
              handleHRaceEngland(false);
            }

            if (lockData?.hrace_dubai === 1) {
              handleHRaceDubai(true);
            } else {
              handleHRaceDubai(false);
            }

            if (lockData?.hrace_bahrain === 1) {
              handleHRaceBahrain(true);
            } else {
              handleHRaceBahrain(false);
            }

            if (lockData?.hrace_australia === 1) {
              handleHRaceAustralia(true);
            } else {
              handleHRaceAustralia(false);
            }

            if (lockData?.hrace_america === 1) {
              handleHRaceAmerica(true);
            } else {
              handleHRaceAmerica(false);
            }

            if (lockData?.hrace_africa === 1) {
              handleHRaceHRaceAfrica(true);
            } else {
              handleHRaceHRaceAfrica(false);
            }

            if (lockData?.greyh_newzealand === 1) {
              handleGreyhNewzealand(true);
            } else {
              handleGreyhNewzealand(false);
            }

            if (lockData?.greyh_britain === 1) {
              handleGreyhBritain(true);
            } else {
              handleGreyhBritain(false);
            }

            if (lockData?.greyh_australia === 1) {
              handleGreyhAustralia(true);
            } else {
              handleGreyhAustralia(false);
            }

            if (lockData?.cric_toss === 1) {
              handleToss(true);
            } else {
              handleToss(false);
            }

            if (lockData?.cric_tie === 1) {
              handleTie(true);
            } else {
              handleTie(false);
            }

            if (lockData?.cric_matchodd === 1) {
              handleMatchOdds(true);
            } else {
              handleMatchOdds(false);
            }

            if (lockData?.cric_figure === 1) {
              handleFigure(true);
            } else {
              handleFigure(false);
            }

            if (lockData?.cric_fancy === 1) {
              handleFancy(true);
            } else {
              handleFancy(false);
            }

            if (lockData?.cric_even_odd === 1) {
              handleEvenOdd(true);
            } else {
              handleEvenOdd(false);
            }

            if (lockData?.cric_cup === 1) {
              handleCupWinner(true);
            } else {
              handleCupWinner(false);
            }

            if (lockData?.casino_tp_studio === 1) {
              handleTeenPattiStudio(true);
            } else {
              handleTeenPattiStudio(false);
            }

            if (lockData?.casino_supernowa === 1) {
              handleSuperNowa(true);
            } else {
              handleSuperNowa(false);
            }

            if (lockData?.casino_betfair === 1) {
              handleBetfairGames(true);
            } else {
              handleBetfairGames(false);
            }

            if (lockData?.casino_royal_casino === 1) {
              handleRoyalCasino(true);
            } else {
              handleRoyalCasino(false);
            }

            if (lockData?.casino_star === 1) {
              handleStarCasino(true);
            } else {
              handleStarCasino(false);
            }
          } else {
            setPageLoad(true);
            //handleTennisMatchOdd(true);
          }
        }
      } catch (error) {
        console.error("Error fetching single event:", error);
      }
    };

    useEffect(() => {
        getUserLockSetting();
    }, [userInfo]); // Empty dependency array

    const handleSubmit = async() => {

        
        handleAnimation(true);
        const betLockObj = {
            casino_tp_studio: TeenPattiStudio,
            casino_royal_casino: RoyalCasino,
            casino_star: StarCasino,
            casino_supernowa: SuperNowa,
            casino_betfair: BetfairGames,
            cric_matchodd: MatchOdds,
            cric_fancy: Fancy,
            cric_toss: Toss,
            cric_tie: Tie,
            cric_even_odd: EvenOdd,
            cric_figure: Figure,
            cric_cup: CupWinner,

            greyh_australia: GreyhAustralia,
            greyh_britain: GreyhBritain,
            greyh_newzealand: GreyhNewzealand,

            hrace_dubai: HRaceDubai,
            hrace_australia:HRaceAustralia,
            hrace_bahrain:HRaceBahrain,
            hrace_france: HRaceFrance,
            hrace_england: HRaceEngland,
            hrace_ireland: HRaceIreland,
            hrace_newzealand: HRaceNewzealand,
            hrace_sweden: HRaceSweden,
            hrace_singapore: HRaceSingapore,
            hrace_america: HRaceAmerica,
            hrace_africa: HRaceAfrica,
            soccer_matchodd: SoccerMatchodd,
            soccer_over_under: SoccerOverUnder,
            tennis_matchodd: TennisMatchOdd,
            casino_betfair_games: BetfairGames,
          }

          try 
          {
            let userId = userInfo.data._id;  
           
            const response = await axiosInstance.post("/company/save-bet-lock/"+userId,betLockObj); 
            if(response.data.status) { 
                handleAnimation(false);
                 
                /*toast.success(response.data.message, {
                    position: "top-center",
                    autoClose: true,
                    hideProgressBar: true,
                    closeOnClick:true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                    transition: "Bounce",
                    });*/
                navigate('/agent/bet-lock');
            } else {

            }

          }
          catch (error) {
            console.error("Error save betlock setting:", error);
            handleAnimation(false);
          } 
    }
    return (
       
        <AgentLayout>
             <ToastContainer />
             <style>{
            `.bigcb {
                width: 20px;
                height: 20px;
                margin-bottom: 10px;
            }
            `}

        </style>
           <div class="bets-section-wrapper">
  <div class="row">
    <div class="col-12 col-md-4">
    <div style={{width:"100%",textAlign:"center",display: pageLoad?"none":"block"}}>
      <img src="../../assets/images/loadinggif.gif" alt="Loader" />
      </div>
      
      <div class="card" style={{display: pageLoad?"":"none"}}>
        <div class="card-header">
          <strong>Allowed Market Types</strong>
        </div>
        <div class="card-body" id="betlockcardbody" style={{paddingLeft:"40px"}}>
         
            <hr/>
            <label class="form-check-label" for="inlineCheckbox1" style={{marginLeft:"5px"}}>
              <h5>
                <b>All Casino</b>
              </h5>
            </label>
            <br/>
            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              onChange={handleCheckbox} type="checkbox" value="TeenPattiStudio" checked={TeenPattiStudio}/>
              <label class="form-check-label" for="inlineCheckbox1">TeenPatti Studio</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="RoyalCasino" checked={RoyalCasino}/>
              <label class="form-check-label" for="inlineCheckbox1">Royal Casino</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              type="checkbox" onChange={handleCheckbox} value="BetfairGames" checked={BetfairGames}/>
              <label class="form-check-label" for="inlineCheckbox1">Betfair Games</label>
            </div>

            <br/>
            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="StarCasino" checked={StarCasino}/>
              <label class="form-check-label" for="inlineCheckbox1">Star Casino</label>
            </div>

            <br/>
            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"  
              type="checkbox" onChange={handleCheckbox} value="SuperNowa" checked={SuperNowa}/>
              <label class="form-check-label" for="inlineCheckbox1">Super Nowa</label>
            </div>

            <hr/>
            <label class="form-check-label" for="inlineCheckbox1" style={{marginLeft:"5px"}}>
              <h5>
                <b>Cricket</b>
              </h5>
            </label>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="Figure" checked={Figure}/>
              <label class="form-check-label" for="inlineCheckbox1">Figure</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="Fancy" checked={Fancy}/>
              <label class="form-check-label" for="inlineCheckbox1">Fancy</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="MatchOdds" checked={MatchOdds}/>
              <label class="form-check-label" for="inlineCheckbox1">Match Odds</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"  type="checkbox" 
               value="EvenOdd" onChange={handleCheckbox} checked={EvenOdd}/>
              <label class="form-check-label" for="inlineCheckbox1">Even / Odd</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="Toss" checked={Toss}/>
              <label class="form-check-label" for="inlineCheckbox1">Toss</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="Tie" checked={Tie}/>
              <label class="form-check-label" for="inlineCheckbox1">Tie</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"  
              type="checkbox" onChange={handleCheckbox} value="CupWinner" checked={CupWinner}/>
              <label class="form-check-label" for="inlineCheckbox1">Cup Winner</label>
            </div>
            <hr/>

            <label class="form-check-label" for="inlineCheckbox1" style={{marginLeft:"5px"}}>
              <h5>
                <b>Greyhound</b>
              </h5>
            </label>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"  
              type="checkbox" onChange={handleCheckbox} value="GreyhAustralia" checked={GreyhAustralia} />
              <label class="form-check-label" for="inlineCheckbox1">Australia</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
               type="checkbox" onChange={handleCheckbox} value="GreyhBritain" checked={GreyhBritain}/>
              <label class="form-check-label" for="inlineCheckbox1">Britian</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="GreyhNewzealand" checked={GreyhNewzealand}/>
              <label class="form-check-label" for="inlineCheckbox1">New Zealand</label>
            </div>
            <br/>
            <hr/>

            <label class="form-check-label" for="inlineCheckbox1" style={{marginLeft:"5px"}}>
              <h5>
                <b>Horse Race</b>
              </h5>
            </label>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              type="checkbox" onChange={handleCheckbox} value="HRaceDubai" checked={HRaceDubai}/>
              <label class="form-check-label" for="inlineCheckbox1">Dubai</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              type="checkbox" onChange={handleCheckbox} value="HRaceAustralia" checked={HRaceAustralia}/>
              <label class="form-check-label" for="inlineCheckbox1">Australia</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="HRaceBahrain" checked={HRaceBahrain}/>
              <label class="form-check-label" for="inlineCheckbox1">Bahrain</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="HRaceFrance" checked={HRaceFrance}/>
              <label class="form-check-label" for="inlineCheckbox1">France</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="HRaceEngland" checked={HRaceEngland}/>
              <label class="form-check-label" for="inlineCheckbox1">England</label>
            </div>
            <br/>
          
            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" type="checkbox"
               value="HRaceIreland" onChange={handleCheckbox} checked={HRaceIreland}/>
              <label class="form-check-label" for="inlineCheckbox1">Ireland</label>
            </div>
            <br/>
           
            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" type="checkbox" 
              value="HRaceNewzealand" onChange={handleCheckbox} checked={HRaceNewzealand}/>
              <label class="form-check-label" for="inlineCheckbox1">New Zealand</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"  type="checkbox" 
              value="HRaceSweden" onChange={handleCheckbox} checked={HRaceSweden}/>
              <label class="form-check-label" for="inlineCheckbox1">Sweden</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              type="checkbox" onChange={handleCheckbox} value="HRaceSingapore" checked={HRaceSingapore}/>
              <label class="form-check-label" for="inlineCheckbox1">Singapore</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" type="checkbox" 
              value="HRaceAmerica" onChange={handleCheckbox} checked={HRaceAmerica}/>
              <label class="form-check-label" for="inlineCheckbox1">America</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb"
              type="checkbox" onChange={handleCheckbox} value="HRaceAfrica" checked={HRaceAfrica}/>
              <label class="form-check-label" for="inlineCheckbox1">Africa</label>
            </div>
            <br/>
            <hr/>

            <label class="form-check-label" for="inlineCheckbox1" style={{marginLeft:"5px"}}>
              <h5>
                <b>Soccer</b>
              </h5>
            </label>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              type="checkbox" onChange={handleCheckbox} value="SoccerMatchodd" checked={SoccerMatchodd}/>
              <label class="form-check-label" for="inlineCheckbox1">Match Odds</label>
            </div>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              type="checkbox" onChange={handleCheckbox} value="SoccerOverUnder" checked={SoccerOverUnder}/>
              <label class="form-check-label" for="inlineCheckbox1">Over/Under Goals</label>
            </div>
             <br/>
            <hr/>

            <label class="form-check-label" for="inlineCheckbox1" style={{marginLeft:"5px"}}>
              <h5>
                <b>Tennis</b>
              </h5>
            </label>
            <br/>

            <div class="form-check form-check-inline">
              <input class="form-check-input bigcb" 
              type="checkbox" onChange={handleCheckbox} value="TennisMatchOdd" checked={TennisMatchOdd}/>
              <label class="form-check-label" for="inlineCheckbox1">Match Odds</label>
            </div>
             <br/>
            
            <div class="editsbmtbtn">
              <input type="button" class="betsSubmit" 
              onClick={handleSubmit}
              style={{marginRight:"4px",border:"0px",cursor:"pointer",
              padding:"8px 19px",display:animation?"none":""}}
              id="betlocksavebtn" name="betlocksavebtn" value="Save"/>

            <button type="button" class="betsSubmit"
                style={{marginRight:"4px",border:"0px",cursor:"pointer",
                padding:"8px 19px",display:animation?"":"none"}}>
                <div>
                Save <div class="ld ld-ball ld-flip" id="bp_loader_web">
                    </div>
                </div>
            </button>

           
            </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
        </AgentLayout>
    )

}

export default BetLock;